import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ManageCompanies from './pages/ManageCompanies';
import ManageRegistrations from './pages/ManageRegistrations';
import ManageLicensePlates from './pages/ManageLicensePlates';
import ManageCountries from './pages/ManageCountries';
import ManageBusCompanies from './pages/ManageBusCompanies';
import ImportRegistrations from './pages/ImportRegistrations';
import Migration from './pages/Migration';
import Privacy from './pages/Privacy';
import Support from './pages/Support';
import About from './pages/About';
import { useAuth } from './contexts/AuthContext';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return user ? <>{children}</> : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/manage-registrations"
            element={
              <PrivateRoute>
                <ManageRegistrations />
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-companies"
            element={
              <PrivateRoute>
                <ManageCompanies />
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-license-plates"
            element={
              <PrivateRoute>
                <ManageLicensePlates />
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-countries"
            element={
              <PrivateRoute>
                <ManageCountries />
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-bus-companies"
            element={
              <PrivateRoute>
                <ManageBusCompanies />
              </PrivateRoute>
            }
          />
          <Route
            path="/import-registrations"
            element={
              <PrivateRoute>
                <ImportRegistrations />
              </PrivateRoute>
            }
          />
          <Route
            path="/migration"
            element={
              <PrivateRoute>
                <Migration />
              </PrivateRoute>
            }
          />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;